<template>
  <el-row class="container">
    <aside>
      <sidebar/>
    </aside>
    <div class="main">
      <navbar/>
      <Breadcrumb v-if="!this.$route.meta.hideBreadcrumb"/>
      <div class="content" :style="{top:this.$route.meta.hideBreadcrumb?'80px':'175px'}">
        <router-view/>
      </div>
    </div>
  </el-row>
</template>

<style scoped>
.container {
  display: flex;
  height: 100%;
}

aside {
  flex: 0 0 230px;
  background: #2b303b;
  position: relative;
}

.main {
  flex: 1;
  background: #f2f4f8;
  position: relative;
}

.main .content {
  position: absolute;
  top: 175px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow-y: scroll;
  padding: 20px;
}
</style>
<script>
import Sidebar from '@/components/Sidebar'
import Navbar from '@/components/Navbar'
import Breadcrumb from '@/components/Breadcrumb'

export default {
  created: function () {
  },
  components: { Sidebar, Navbar, Breadcrumb }
}
</script>



// WEBPACK FOOTER //
// Main.vue?558ebb78